module.exports = __webpack_public_path__ + "img/Menu-02.12eb8b89.png";